const React = require("react");

function MenuAlt1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h8m-8 6h16"
  }));
}

module.exports = MenuAlt1Icon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MenuAlt1Icon.js
 ** module id = 561
 ** module chunks = 0
 **/